export default __webpack_public_path__ + "static/media/adhar-access.b2d87417.webp";